/* WheelX : mention sous chaque vue 3D */
(function(){
var T="Maquette 3D réalisée par <b>PZ3D_Design</b> pour WheelX-Parts";
var inF=false;try{inF=window.parent!==window}catch(e){inF=true}
var st=document.createElement("style");
st.textContent=".wx-cred{margin:8px 0 0;text-align:center;font:500 11px/1.3 'Instrument Sans',system-ui,sans-serif;letter-spacing:.04em;color:#8b919d}.wx-cred b{color:#c9cdd6;font-weight:600}.wx-cred.fx{position:fixed;left:0;right:0;bottom:6px;margin:0;z-index:2147483000;pointer-events:none}";
(document.head||document.documentElement).appendChild(st);
function mk(c){var p=document.createElement("p");p.className="wx-cred"+(c||"");p.innerHTML=T;return p}
function after(el){if(!el||!el.parentNode)return;var n=el.nextElementSibling;if(n&&n.classList.contains("wx-cred"))return;el.parentNode.insertBefore(mk(),el.nextSibling)}
function run(){
if(inF){if(!document.querySelector(".wx-cred"))document.body.appendChild(mk(" fx"));return}
after(document.getElementById("gl"));after(document.getElementById("fk"));
}
if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",run);else run();
})();
